import { Pipe, PipeTransform } from '@angular/core';
import { AgentKeys } from '@ag-common-lib/public-api';
import { DxFilterOperators } from 'ag-common-svc/lib/services/elastic-search.services/base-elastic-search-service';
import { AgentSearchService } from 'ag-common-svc/lib/services/agent-search';
import { getAgentFullName } from 'ag-common-svc/lib/services/agent.service/agent-service-utils';

@Pipe({
  name: 'mgaTeamLeadDescription',
})
export class MgaTeamLeadDescriptionPipe implements PipeTransform {
  constructor(private agentSearchService: AgentSearchService) {}

  async transform(value: string): Promise<string> {
    if (!value) {
      return Promise.resolve('');
    }
    const agent = await this.agentSearchService.getByAgentId(value);

    return getAgentFullName(agent);
  }
}
